import React from 'react';
import { Section } from './Section';
import { Play } from 'lucide-react';
const videos = [{
  id: 'QuF1R8YVIyU',
  title: 'Danza Rota',
  artist: 'Soda Stereo',
  url: 'https://youtu.be/QuF1R8YVIyU'
}, {
  id: 'oC_rc2fMq7U',
  title: 'En Camino',
  artist: 'Soda Stereo',
  url: 'https://youtu.be/oC_rc2fMq7U'
}, {
  id: '0io60XCMSro',
  title: 'Llorando en el espejo',
  artist: 'Serú Girán',
  url: 'https://youtu.be/0io60XCMSro'
}];
export function PopularVideos() {
  return <Section className="bg-surface/50 rounded-3xl my-12" data-id="element-77">
      <div className="text-center mb-16" data-id="element-78">
        <h2 className="text-3xl md:text-5xl font-serif mb-4" data-id="element-79">
          Empezá por estos 3 videos
        </h2>
        <p className="text-xl text-amber-400/90 font-serif italic" data-id="element-80">
          Los más populares
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-81">
        {videos.map(video => <a key={video.id} href={video.url} target="_blank" rel="noopener noreferrer" className="group block bg-surface border border-white/5 rounded-2xl overflow-hidden hover:border-amber-500/30 transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_0_30px_rgba(212,168,83,0.1)]" data-id="element-82">
            <div className="relative aspect-video overflow-hidden" data-id="element-83">
              <img src={`https://img.youtube.com/vi/${video.id}/maxresdefault.jpg`} alt={`${video.title} - ${video.artist}`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-84" />
              <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-colors duration-500 flex items-center justify-center" data-id="element-85">
                <div className="w-16 h-16 rounded-full bg-amber-500/90 flex items-center justify-center text-background transform scale-90 opacity-0 group-hover:scale-100 group-hover:opacity-100 transition-all duration-300" data-id="element-86">
                  <Play className="w-8 h-8 ml-1" fill="currentColor" data-id="element-87" />
                </div>
              </div>
            </div>
            <div className="p-6" data-id="element-88">
              <h3 className="text-xl font-bold mb-1" data-id="element-89">{video.title}</h3>
              <p className="text-gray-400 mb-6" data-id="element-90">{video.artist}</p>
              <div className="inline-flex items-center text-amber-400 font-medium text-sm group-hover:text-amber-300 transition-colors" data-id="element-91">
                Ver video{' '}
                <span className="ml-2 group-hover:translate-x-1 transition-transform" data-id="element-92">
                  →
                </span>
              </div>
            </div>
          </a>)}
      </div>
    </Section>;
}